// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-box_d66c6ce0 {
  height: auto;
  transition: height 0.3s ease-out;
}
.slide-box_no-animation_d66c6ce0 {
  transition: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slide-box": `slide-box_d66c6ce0`,
	"slide-box_no-animation": `slide-box_no-animation_d66c6ce0`
};
export default ___CSS_LOADER_EXPORT___;
